<template>
  <div class="text-center">
    <div class="row no-gutters">
      <div class="col pb-2">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setVesselsToTable(1)">First</button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setVesselsToTable(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setVesselsToTable(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-md-auto px-1" v-if="isElite()">
        <div class="float-right text-right ml-2">
          <button id="committeeReport" class="mr-2 e-btn e-btn-blue-gray force-white-all"
                  :disabled="vesselList.length === 0 || loading === true"
                  :class="vesselList.length === 0 || loading === true ? 'e-btn-blue-gray-disabled' : ''"
                  @click="downloadReportStatusHistory"
          >
            <font-awesome-icon class="mr-1" icon="download"/>
            Download Report Status History
          </button>
        </div>
      </div>
      <div class="col-3 pb-2">
        <input type="text" name="vesselSearch" class="form-control form-control-sm" v-model="requestPayload.search" placeholder="Search Vessel">
      </div>
    </div>
    <div class="row no-gutters" style="height: 80vh; overflow-y: auto;">
      <div class="col-sm-12">
        <table class="small e-tbl" style="overflow-x: auto; width: 2500px;">
          <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
          <tr>
            <th class="align-middle" style="width: 1em" scope="col">#</th>
            <!--            <th class="align-middle no-select cursor-pointer" scope="col" @click="sorterArrowSetDirection('name')">-->
            <th class="align-middle no-select cursor-pointer text-wrap" scope="col" style="padding: 0; position: relative; width: 200px;">
              SHIP NAME

              <filter-like-excel
                v-show="loading === false"
                :module="'vessel_list'"
                :column-name="'name'"
                :filter-option-to-right="true"
                @setFilterParam="setFilterParam"
              />
            </th>
            <th class="align-middle no-select cursor-pointer text-wrap" scope="col" style="padding: 0; position: relative; width: 100px;">
              FLAG
              <filter-like-excel
                v-show="loading === false"
                :module="'vessel_list'"
                :column-name="'flag_id'"
                @setFilterParam="setFilterParam"
              />
            </th>
            <th class="align-middle no-select cursor-pointer text-wrap" scope="col" style="padding: 0; position: relative; width: 250px;">
              MANAGEMENT
              <filter-like-excel
                v-show="loading === false"
                :module="'vessel_list'"
                :column-name="'management_company_id'"
                @setFilterParam="setFilterParam"
              />
            </th>
            <th class="align-middle no-select cursor-pointer text-wrap" scope="col" style="padding: 0; position: relative; width: 150px;">
              FLEET
              <filter-like-excel
                v-show="loading === false"
                :module="'vessel_list'"
                :column-name="'fleet_id'"
                @setFilterParam="setFilterParam"
              />
            </th>
            <th style="min-width: 570px;" scope="col">{{ beforePreviousYear }}</th>
            <th style="min-width: 570px;" scope="col">{{ previousYear }}</th>
            <th style="min-width: 570px;" scope="col">{{ currentYear }}</th>
            <th class="align-middle no-select cursor-pointer" scope="col" style="padding: 0; position: relative; width: 50px;">ACTION</th>
          </tr>
          </thead>
          <tbody>

          <tr v-if="loading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="(vessel, index) in vesselList" :key="vessel.id" class="ia-vessel-list no-select" :title="vessel.name" @dblclick="viewVesselAuditRecord(vessel.id)">
              <td class="align-middle">{{ index + pagination.from }}</td>
              <td class="align-middle text-uppercase">{{ vessel.name }}</td>
              <td class="align-middle">{{ vessel.flag ? vessel.flag.name : '' }}</td>
              <td class="align-middle">{{ vessel.management_company ? vessel.management_company.name : '' }}</td>
              <td class="align-middle">{{ vessel.fleet ? vessel.fleet.name : '' }}</td>
              <td class="align-middle p-2" style="min-width: 300px;">
                <!--SMS-->
                <div class="row" v-if="vessel.audits_per_year.sms[beforePreviousYear]">
                  <div class="col-lg-2 col-md-2 col-sm-12 pr-4 d-flex align-items-center">
                    <div class="row">
                      <div class="col-6 pr-0">
                        <span class="font-weight-bold" style="font-size: 8pt;">SMS</span>
                      </div>
                      <div class="col-6 pl-3">
                        <span class="font-weight-bold bg-primary text-light ml-1" style="font-size: 8pt; border-radius: 75%;" v-if="vessel.audits_per_year?.sms[beforePreviousYear]?.audit_type_2[0] === 1">&nbsp;A&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #fd8b01" v-else-if="vessel.audits_per_year?.sms[beforePreviousYear]?.audit_type_2[0] === 2">&nbsp;O&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #a847a6;" v-if="vessel.audits_per_year?.sms[beforePreviousYear]?.is_extended === 1">&nbsp;E&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.audits_per_year?.sms[beforePreviousYear]?.audit_type_3[0] === 2">&nbsp;R&nbsp;</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-7 col-sm-12 pl-1 pr-0 d-flex align-items-center justify-content-center">
                    <div class="font-weight-bold">
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.sms[beforePreviousYear]?.is_extended === 1">{{vessel.audits_per_year?.sms[beforePreviousYear]?.issued_date_extension['date-picker']}}</span>
                      <span style="font-size: 11pt; color: #a847a6" class="p-2" v-if="vessel.audits_per_year?.sms[beforePreviousYear]?.is_extended === 1">➨</span>
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.sms[beforePreviousYear]?.is_extended === 1">{{vessel.audits_per_year?.sms[beforePreviousYear]?.extended_date['date-picker']}}</span>
                      <span style="font-size: 8pt;" class="badge badge-danger ml-2" title="AUDIT DATE">{{vessel.audits_per_year?.sms[beforePreviousYear]?.audit_date_start['date-picker']}}</span>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-3 col-sm-12 pl-0 d-flex align-items-center">
                    <div class="font-weight-bold badge text-light w-75 text-wrap" style="background-color: #42b983; font-size: 8pt;" :style="{backgroundColor: '#' + updated_report_status_names.filter(item => {
                  return item.id === vessel.audits_per_year?.sms[beforePreviousYear]?.report_status_id
                })[0]?.color ?? '42b983' }">
                      {{ updated_report_status_names.filter(item => {
                      return item.id === vessel.audits_per_year?.sms[beforePreviousYear]?.report_status_id
                    })[0]?.name ?? 'APPOINTED' }}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-if="(vessel.audits_per_year?.sms?.[beforePreviousYear]?.auditors?.length ?? 0) >= 1">
                      {{vessel.audits_per_year?.sms[beforePreviousYear]?.auditors[0]?.last_name}}, {{vessel.audits_per_year?.sms[beforePreviousYear]?.auditors[0]?.first_name}}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-else>
                      {{ vessel.audits_per_year?.sms[beforePreviousYear]?.auditors.length
                      ? `${vessel.audits_per_year.sms[beforePreviousYear].auditors.last_name}, ${vessel.audits_per_year.sms[beforePreviousYear].auditors.first_name}`
                      : '' }}
                    </div>
                  </div>
                </div>
                <!--END SMS-->
                <!--ISPS-->
                <div class="row" v-if="vessel.audits_per_year.isps[beforePreviousYear]">
                  <div class="col-lg-2 col-md-2 col-sm-12 pr-4 d-flex align-items-center">
                    <div class="row">
                      <div class="col-6 pr-0">
                        <span class="font-weight-bold" style="font-size: 8pt;">ISPS</span>
                      </div>
                      <div class="col-6 pl-3">
                        <span class="font-weight-bold bg-primary text-light ml-1" style="font-size: 8pt; border-radius: 75%;" v-if="vessel.audits_per_year?.isps[beforePreviousYear]?.audit_type_2[0] === 1">&nbsp;A&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #fd8b01" v-else-if="vessel.audits_per_year?.isps[beforePreviousYear]?.audit_type_2[0] === 2">&nbsp;O&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #a847a6;" v-if="vessel.audits_per_year?.isps[beforePreviousYear]?.is_extended === 1">&nbsp;E&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.audits_per_year?.isps[beforePreviousYear]?.audit_type_3[0] === 2">&nbsp;R&nbsp;</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-7 col-sm-12 pl-1 pr-0 d-flex align-items-center justify-content-center">
                    <div class="font-weight-bold">
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.isps[beforePreviousYear]?.is_extended === 1">{{vessel.audits_per_year?.isps[beforePreviousYear]?.issued_date_extension['date-picker']}}</span>
                      <span style="font-size: 11pt; color: #a847a6" class="p-2" v-if="vessel.audits_per_year?.isps[beforePreviousYear]?.is_extended === 1">➨</span>
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.isps[beforePreviousYear]?.is_extended === 1">{{vessel.audits_per_year?.isps[beforePreviousYear]?.extended_date['date-picker']}}</span>
                      <span style="font-size: 8pt;" class="badge badge-danger ml-2" title="AUDIT DATE">{{vessel.audits_per_year?.isps[beforePreviousYear]?.audit_date_start['date-picker']}}</span>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-3 col-sm-12 pl-0 d-flex align-items-center">
                    <div class="font-weight-bold badge text-light w-75 text-wrap" style="background-color: #42b983; font-size: 8pt;" :style="{backgroundColor: '#' + updated_report_status_names.filter(item => {
                  return item.id === vessel.audits_per_year?.isps[beforePreviousYear]?.report_status_id
                })[0]?.color ?? '42b983' }">
                      {{ updated_report_status_names.filter(item => {
                      return item.id === vessel.audits_per_year?.isps[beforePreviousYear]?.report_status_id
                    })[0]?.name ?? 'APPOINTED' }}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-if="(vessel.audits_per_year?.isps?.[beforePreviousYear]?.auditors?.length ?? 0) >= 1">
                      {{vessel.audits_per_year?.isps[beforePreviousYear]?.auditors[0]?.last_name}}, {{vessel.audits_per_year?.isps[beforePreviousYear]?.auditors[0]?.first_name}}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-else>
                      {{ vessel.audits_per_year?.isps[beforePreviousYear]?.auditors.length
                      ? `${vessel.audits_per_year.isps[beforePreviousYear].auditors.last_name}, ${vessel.audits_per_year.isps[beforePreviousYear].auditors.first_name}`
                      : '' }}
                    </div>
                  </div>
                </div>
                <!--END ISPS-->
                <!--CYBER-->
                <div class="row" v-if="vessel.audits_per_year.cyber[beforePreviousYear]">
                  <div class="col-lg-2 col-md-2 col-sm-12 pr-4 d-flex align-items-center">
                    <div class="row">
                      <div class="col-6 pr-0">
                        <span class="font-weight-bold" style="font-size: 8pt;">CYBER</span>
                      </div>
                      <div class="col-6 pl-3">
                        <span class="font-weight-bold bg-primary text-light ml-1" style="font-size: 8pt; border-radius: 75%;" v-if="vessel.audits_per_year?.cyber[beforePreviousYear]?.audit_type_2[0] === 1">&nbsp;A&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #fd8b01" v-else-if="vessel.audits_per_year?.cyber[beforePreviousYear]?.audit_type_2[0] === 2">&nbsp;O&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #a847a6;" v-if="vessel.audits_per_year?.cyber[beforePreviousYear]?.is_extended === 1">&nbsp;E&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.audits_per_year?.cyber[beforePreviousYear]?.audit_type_3[0] === 2">&nbsp;R&nbsp;</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-7 col-sm-12 pl-1 pr-0 d-flex align-items-center justify-content-center">
                    <div class="font-weight-bold">
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.cyber[beforePreviousYear]?.is_extended === 1">{{vessel.audits_per_year?.cyber[beforePreviousYear]?.issued_date_extension['date-picker']}}</span>
                      <span style="font-size: 11pt; color: #a847a6" class="p-2" v-if="vessel.audits_per_year?.cyber[beforePreviousYear]?.is_extended === 1">➨</span>
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.cyber[beforePreviousYear]?.is_extended === 1">{{vessel.audits_per_year?.cyber[beforePreviousYear]?.extended_date['date-picker']}}</span>
                      <span style="font-size: 8pt;" class="badge badge-danger ml-2" title="AUDIT DATE">{{vessel.audits_per_year?.cyber[beforePreviousYear]?.audit_date_start['date-picker']}}</span>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-3 col-sm-12 pl-0 d-flex align-items-center">
                    <div class="font-weight-bold badge text-light w-75 text-wrap" style="background-color: #42b983; font-size: 8pt;" :style="{backgroundColor: '#' + updated_report_status_names.filter(item => {
                  return item.id === vessel.audits_per_year?.cyber[beforePreviousYear]?.report_status_id
                })[0]?.color ?? '42b983' }">
                      {{ updated_report_status_names.filter(item => {
                      return item.id === vessel.audits_per_year?.cyber[beforePreviousYear]?.report_status_id
                    })[0]?.name ?? 'APPOINTED' }}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-if="(vessel.audits_per_year?.cyber?.[beforePreviousYear]?.auditors?.length ?? 0) >= 1">
                      {{vessel.audits_per_year?.cyber[beforePreviousYear]?.auditors[0]?.last_name}}, {{vessel.audits_per_year?.cyber[beforePreviousYear]?.auditors[0]?.first_name}}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-else>
                      {{ vessel.audits_per_year?.cyber[beforePreviousYear]?.auditors.length
                      ? `${vessel.audits_per_year.cyber[beforePreviousYear].auditors.last_name}, ${vessel.audits_per_year.cyber[beforePreviousYear].auditors.first_name}`
                      : '' }}
                    </div>
                  </div>
                </div>
                <!--END CYBER-->
              </td>
              <td class="align-middle p-2" style="min-width: 300px;">
                <!--SMS-->
                <div class="row" v-if="vessel.audits_per_year.sms[previousYear]">
                  <div class="col-lg-2 col-md-2 col-sm-12 pr-4 d-flex align-items-center">
                    <div class="row">
                      <div class="col-6 pr-0">
                        <span class="font-weight-bold" style="font-size: 8pt;">SMS</span>
                      </div>
                      <div class="col-6 pl-3">
                        <span class="font-weight-bold bg-primary text-light ml-1" style="font-size: 8pt; border-radius: 75%;" v-if="vessel.audits_per_year?.sms[previousYear]?.audit_type_2[0] === 1">&nbsp;A&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #fd8b01" v-else-if="vessel.audits_per_year?.sms[previousYear]?.audit_type_2[0] === 2">&nbsp;O&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #a847a6;" v-if="vessel.audits_per_year?.sms[previousYear]?.is_extended === 1">&nbsp;E&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.audits_per_year?.sms[previousYear]?.audit_type_3[0] === 2">&nbsp;R&nbsp;</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-7 col-sm-12 pl-1 pr-0 d-flex align-items-center justify-content-center">
                    <div class="font-weight-bold">
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.sms[previousYear]?.is_extended === 1">{{vessel.audits_per_year?.sms[previousYear]?.issued_date_extension['date-picker']}}</span>
                      <span style="font-size: 11pt; color: #a847a6" class="p-2" v-if="vessel.audits_per_year?.sms[previousYear]?.is_extended === 1">➨</span>
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.sms[previousYear]?.is_extended === 1">{{vessel.audits_per_year?.sms[previousYear]?.extended_date['date-picker']}}</span>
                      <span style="font-size: 8pt;" class="badge badge-danger ml-2" title="AUDIT DATE">{{vessel.audits_per_year?.sms[previousYear]?.audit_date_start['date-picker']}}</span>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-3 col-sm-12 pl-0 d-flex align-items-center">
                    <div class="font-weight-bold badge text-light w-75 text-wrap" style="background-color: #42b983; font-size: 8pt;" :style="{backgroundColor: '#' + updated_report_status_names.filter(item => {
                  return item.id === vessel.audits_per_year?.sms[previousYear]?.report_status_id
                })[0]?.color ?? '42b983' }">
                      {{ updated_report_status_names.filter(item => {
                      return item.id === vessel.audits_per_year?.sms[previousYear]?.report_status_id
                    })[0]?.name ?? 'APPOINTED' }}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-if="(vessel.audits_per_year?.sms?.[previousYear]?.auditors?.length ?? 0) >= 1">
                      {{vessel.audits_per_year?.sms[previousYear]?.auditors[0]?.last_name}}, {{vessel.audits_per_year?.sms[previousYear]?.auditors[0]?.first_name}}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-else>
                      {{ vessel.audits_per_year?.sms[previousYear]?.auditors.length
                      ? `${vessel.audits_per_year.sms[previousYear].auditors.last_name}, ${vessel.audits_per_year.sms[previousYear].auditors.first_name}`
                      : '' }}
                    </div>
                  </div>
                </div>
                <!--END SMS-->
                <!--ISPS-->
                <div class="row" v-if="vessel.audits_per_year.isps[previousYear]">
                  <div class="col-lg-2 col-md-2 col-sm-12 pr-4 d-flex align-items-center">
                    <div class="row">
                      <div class="col-6 pr-0">
                        <span class="font-weight-bold" style="font-size: 8pt;">ISPS</span>
                      </div>
                      <div class="col-6 pl-3">
                        <span class="font-weight-bold bg-primary text-light ml-1" style="font-size: 8pt; border-radius: 75%;" v-if="vessel.audits_per_year?.isps[previousYear]?.audit_type_2[0] === 1">&nbsp;A&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #fd8b01" v-else-if="vessel.audits_per_year?.isps[previousYear]?.audit_type_2[0] === 2">&nbsp;O&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #a847a6;" v-if="vessel.audits_per_year?.isps[previousYear]?.is_extended === 1">&nbsp;E&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.audits_per_year?.isps[previousYear]?.audit_type_3[0] === 2">&nbsp;R&nbsp;</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-7 col-sm-12 pl-1 pr-0 d-flex align-items-center justify-content-center">
                    <div class="font-weight-bold">
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.isps[previousYear]?.is_extended === 1">{{vessel.audits_per_year?.isps[previousYear]?.issued_date_extension['date-picker']}}</span>
                      <span style="font-size: 11pt; color: #a847a6" class="p-2" v-if="vessel.audits_per_year?.isps[previousYear]?.is_extended === 1">➨</span>
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.isps[previousYear]?.is_extended === 1">{{vessel.audits_per_year?.isps[previousYear]?.extended_date['date-picker']}}</span>
                      <span style="font-size: 8pt;" class="badge badge-danger ml-2" title="AUDIT DATE">{{vessel.audits_per_year?.isps[previousYear]?.audit_date_start['date-picker']}}</span>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-3 col-sm-12 pl-0 d-flex align-items-center">
                    <div class="font-weight-bold badge text-light w-75 text-wrap" style="background-color: #42b983; font-size: 8pt;" :style="{backgroundColor: '#' + updated_report_status_names.filter(item => {
                  return item.id === vessel.audits_per_year?.isps[previousYear]?.report_status_id
                })[0]?.color ?? '42b983' }">
                      {{ updated_report_status_names.filter(item => {
                      return item.id === vessel.audits_per_year?.isps[previousYear]?.report_status_id
                    })[0]?.name ?? 'APPOINTED' }}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-if="(vessel.audits_per_year?.isps?.[previousYear]?.auditors?.length ?? 0) >= 1">
                      {{vessel.audits_per_year?.isps[previousYear]?.auditors[0]?.last_name}}, {{vessel.audits_per_year?.isps[previousYear]?.auditors[0]?.first_name}}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-else>
                      {{ vessel.audits_per_year?.isps[previousYear]?.auditors.length
                      ? `${vessel.audits_per_year.isps[previousYear].auditors.last_name}, ${vessel.audits_per_year.isps[previousYear].auditors.first_name}`
                      : '' }}
                    </div>
                  </div>
                </div>
                <!--END ISPS-->
                <!--CYBER-->
                <div class="row" v-if="vessel.audits_per_year.cyber[previousYear]">
                  <div class="col-lg-2 col-md-2 col-sm-12 pr-4 d-flex align-items-center">
                    <div class="row">
                      <div class="col-6 pr-0">
                        <span class="font-weight-bold" style="font-size: 8pt;">CYBER</span>
                      </div>
                      <div class="col-6 pl-3">
                        <span class="font-weight-bold bg-primary text-light ml-1" style="font-size: 8pt; border-radius: 75%;" v-if="vessel.audits_per_year?.cyber[previousYear]?.audit_type_2[0] === 1">&nbsp;A&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #fd8b01" v-else-if="vessel.audits_per_year?.cyber[previousYear]?.audit_type_2[0] === 2">&nbsp;O&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #a847a6;" v-if="vessel.audits_per_year?.cyber[previousYear]?.is_extended === 1">&nbsp;E&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.audits_per_year?.cyber[previousYear]?.audit_type_3[0] === 2">&nbsp;R&nbsp;</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-7 col-sm-12 pl-1 pr-0 d-flex align-items-center justify-content-center">
                    <div class="font-weight-bold">
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.cyber[previousYear]?.is_extended === 1">{{vessel.audits_per_year?.cyber[previousYear]?.issued_date_extension['date-picker']}}</span>
                      <span style="font-size: 11pt; color: #a847a6" class="p-2" v-if="vessel.audits_per_year?.cyber[previousYear]?.is_extended === 1">➨</span>
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.cyber[previousYear]?.is_extended === 1">{{vessel.audits_per_year?.cyber[previousYear]?.extended_date['date-picker']}}</span>
                      <span style="font-size: 8pt;" class="badge badge-danger ml-2" title="AUDIT DATE">{{vessel.audits_per_year?.cyber[previousYear]?.audit_date_start['date-picker']}}</span>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-3 col-sm-12 pl-0 d-flex align-items-center">
                    <div class="font-weight-bold badge text-light w-75 text-wrap" style="background-color: #42b983; font-size: 8pt;" :style="{backgroundColor: '#' + updated_report_status_names.filter(item => {
                  return item.id === vessel.audits_per_year?.cyber[previousYear]?.report_status_id
                })[0]?.color ?? '42b983' }">
                      {{ updated_report_status_names.filter(item => {
                      return item.id === vessel.audits_per_year?.cyber[previousYear]?.report_status_id
                    })[0]?.name ?? 'APPOINTED' }}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-if="(vessel.audits_per_year?.cyber?.[previousYear]?.auditors?.length ?? 0) >= 1">
                      {{vessel.audits_per_year?.cyber[previousYear]?.auditors[0]?.last_name}}, {{vessel.audits_per_year?.cyber[previousYear]?.auditors[0]?.first_name}}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-else>
                      {{ vessel.audits_per_year?.cyber[previousYear]?.auditors.length
                      ? `${vessel.audits_per_year.cyber[previousYear].auditors.last_name}, ${vessel.audits_per_year.cyber[previousYear].auditors.first_name}`
                      : '' }}
                    </div>
                  </div>
                </div>
                <!--END CYBER-->
              </td>
              <td class="align-middle p-2" style="min-width: 300px;">
                <!--SMS-->
                <div class="row" v-if="vessel.audits_per_year.sms[currentYear]">
                  <div class="col-lg-2 col-md-2 col-sm-12 pr-4 d-flex align-items-center">
                    <div class="row">
                      <div class="col-6 pr-0">
                        <span class="font-weight-bold" style="font-size: 8pt;">SMS</span>
                      </div>
                      <div class="col-6 pl-3">
                        <span class="font-weight-bold bg-primary text-light ml-1" style="font-size: 8pt; border-radius: 75%;" v-if="vessel.audits_per_year?.sms[currentYear]?.audit_type_2[0] === 1">&nbsp;A&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #fd8b01" v-else-if="vessel.audits_per_year?.sms[currentYear]?.audit_type_2[0] === 2">&nbsp;O&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #a847a6;" v-if="vessel.audits_per_year?.sms[currentYear]?.is_extended === 1">&nbsp;E&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.audits_per_year?.sms[currentYear]?.audit_type_3[0] === 2">&nbsp;R&nbsp;</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-7 col-sm-12 pl-1 pr-0 d-flex align-items-center justify-content-center">
                    <div class="font-weight-bold">
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.sms[currentYear]?.is_extended === 1">{{vessel.audits_per_year?.sms[currentYear]?.issued_date_extension['date-picker']}}</span>
                      <span style="font-size: 11pt; color: #a847a6" class="p-2" v-if="vessel.audits_per_year?.sms[currentYear]?.is_extended === 1">➨</span>
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.sms[currentYear]?.is_extended === 1">{{vessel.audits_per_year?.sms[currentYear]?.extended_date['date-picker']}}</span>
                      <span style="font-size: 8pt;" class="badge badge-danger ml-2" title="AUDIT DATE">{{vessel.audits_per_year?.sms[currentYear]?.audit_date_start['date-picker']}}</span>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-3 col-sm-12 pl-0 d-flex align-items-center">
                    <div class="font-weight-bold badge text-light w-75 text-wrap" style="background-color: #42b983; font-size: 8pt;" :style="{backgroundColor: '#' + updated_report_status_names.filter(item => {
                  return item.id === vessel.audits_per_year?.sms[currentYear]?.report_status_id
                })[0]?.color ?? '42b983' }">
                      {{ updated_report_status_names.filter(item => {
                      return item.id === vessel.audits_per_year?.sms[currentYear]?.report_status_id
                    })[0]?.name ?? 'APPOINTED' }}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-if="(vessel.audits_per_year?.sms?.[currentYear]?.auditors?.length ?? 0) >= 1">
                      {{vessel.audits_per_year?.sms[currentYear]?.auditors[0]?.last_name}}, {{vessel.audits_per_year?.sms[currentYear]?.auditors[0]?.first_name}}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-else>
                      {{ vessel.audits_per_year?.sms[currentYear]?.auditors.length
                      ? `${vessel.audits_per_year.sms[currentYear].auditors.last_name}, ${vessel.audits_per_year.sms[currentYear].auditors.first_name}`
                      : '' }}
                    </div>
                  </div>
                </div>
                <!--END SMS-->
                <!--ISPS-->
                <div class="row" v-if="vessel.audits_per_year.isps[currentYear]">
                  <div class="col-lg-2 col-md-2 col-sm-12 pr-4 d-flex align-items-center">
                    <div class="row">
                      <div class="col-6 pr-0">
                        <span class="font-weight-bold" style="font-size: 8pt;">ISPS</span>
                      </div>
                      <div class="col-6 pl-3">
                        <span class="font-weight-bold bg-primary text-light ml-1" style="font-size: 8pt; border-radius: 75%;" v-if="vessel.audits_per_year?.isps[currentYear]?.audit_type_2[0] === 1">&nbsp;A&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #fd8b01" v-else-if="vessel.audits_per_year?.isps[currentYear]?.audit_type_2[0] === 2">&nbsp;O&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #a847a6;" v-if="vessel.audits_per_year?.isps[currentYear]?.is_extended === 1">&nbsp;E&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.audits_per_year?.isps[currentYear]?.audit_type_3[0] === 2">&nbsp;R&nbsp;</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-7 col-sm-12 pl-1 pr-0 d-flex align-items-center justify-content-center">
                    <div class="font-weight-bold">
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.isps[currentYear]?.is_extended === 1">{{vessel.audits_per_year?.isps[currentYear]?.issued_date_extension['date-picker']}}</span>
                      <span style="font-size: 11pt; color: #a847a6" class="p-2" v-if="vessel.audits_per_year?.isps[currentYear]?.is_extended === 1">➨</span>
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.isps[currentYear]?.is_extended === 1">{{vessel.audits_per_year?.isps[currentYear]?.extended_date['date-picker']}}</span>
                      <span style="font-size: 8pt;" class="badge badge-danger ml-2" title="AUDIT DATE">{{vessel.audits_per_year?.isps[currentYear]?.audit_date_start['date-picker']}}</span>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-3 col-sm-12 pl-0 d-flex align-items-center">
                    <div class="font-weight-bold badge text-light w-75 text-wrap" style="background-color: #42b983; font-size: 8pt;" :style="{backgroundColor: '#' + updated_report_status_names.filter(item => {
                  return item.id === vessel.audits_per_year?.isps[currentYear]?.report_status_id
                })[0]?.color ?? '42b983' }">
                      {{ updated_report_status_names.filter(item => {
                      return item.id === vessel.audits_per_year?.isps[currentYear]?.report_status_id
                    })[0]?.name ?? 'APPOINTED' }}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-if="(vessel.audits_per_year?.isps?.[currentYear]?.auditors?.length ?? 0) >= 1">
                      {{vessel.audits_per_year?.isps[currentYear]?.auditors[0]?.last_name}}, {{vessel.audits_per_year?.isps[currentYear]?.auditors[0]?.first_name}}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-else>
                      {{ vessel.audits_per_year?.isps[currentYear]?.auditors.length
                      ? `${vessel.audits_per_year.isps[currentYear].auditors.last_name}, ${vessel.audits_per_year.isps[currentYear].auditors.first_name}`
                      : '' }}
                    </div>
                  </div>
                </div>
                <!--END ISPS-->
                <!--CYBER-->
                <div class="row" v-if="vessel.audits_per_year.cyber[currentYear]">
                  <div class="col-lg-2 col-md-2 col-sm-12 pr-4 d-flex align-items-center">
                    <div class="row">
                      <div class="col-6 pr-0">
                        <span class="font-weight-bold" style="font-size: 8pt;">CYBER</span>
                      </div>
                      <div class="col-6 pl-3">
                        <span class="font-weight-bold bg-primary text-light ml-1" style="font-size: 8pt; border-radius: 75%;" v-if="vessel.audits_per_year?.cyber[currentYear]?.audit_type_2[0] === 1">&nbsp;A&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #fd8b01" v-else-if="vessel.audits_per_year?.cyber[currentYear]?.audit_type_2[0] === 2">&nbsp;O&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #a847a6;" v-if="vessel.audits_per_year?.cyber[currentYear]?.is_extended === 1">&nbsp;E&nbsp;</span>
                        <span class="font-weight-bold text-light ml-1" style="font-size: 8pt; border-radius: 75%; background-color: #bc8526;" v-if="vessel.audits_per_year?.cyber[currentYear]?.audit_type_3[0] === 2">&nbsp;R&nbsp;</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-7 col-sm-12 pl-1 pr-0 d-flex align-items-center justify-content-center">
                    <div class="font-weight-bold">
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.cyber[currentYear]?.is_extended === 1">{{vessel.audits_per_year?.cyber[currentYear]?.issued_date_extension['date-picker']}}</span>
                      <span style="font-size: 11pt; color: #a847a6" class="p-2" v-if="vessel.audits_per_year?.cyber[currentYear]?.is_extended === 1">➨</span>
                      <span style="font-size: 8pt;" v-if="vessel.audits_per_year?.cyber[currentYear]?.is_extended === 1">{{vessel.audits_per_year?.cyber[currentYear]?.extended_date['date-picker']}}</span>
                      <span style="font-size: 8pt;" class="badge badge-danger ml-2" title="AUDIT DATE">{{vessel.audits_per_year?.cyber[currentYear]?.audit_date_start['date-picker']}}</span>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-3 col-sm-12 pl-0 d-flex align-items-center">
                    <div class="font-weight-bold badge text-light w-75 text-wrap" style="background-color: #42b983; font-size: 8pt;" :style="{backgroundColor: '#' + updated_report_status_names.filter(item => {
                  return item.id === vessel.audits_per_year?.cyber[currentYear]?.report_status_id
                })[0]?.color ?? '42b983' }">
                      {{ updated_report_status_names.filter(item => {
                      return item.id === vessel.audits_per_year?.cyber[currentYear]?.report_status_id
                    })[0]?.name ?? 'APPOINTED' }}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-if="(vessel.audits_per_year?.cyber?.[currentYear]?.auditors?.length ?? 0) >= 1">
                      {{vessel.audits_per_year?.cyber[currentYear]?.auditors[0]?.last_name}}, {{vessel.audits_per_year?.cyber[currentYear]?.auditors[0]?.first_name}}
                    </div>
                    <div class="font-weight-bold badge text-light text-wrap text-dark w-50" style="font-size: 8pt;" v-else>
                      {{ vessel.audits_per_year?.cyber[currentYear]?.auditors.length
                      ? `${vessel.audits_per_year.cyber[currentYear].auditors.last_name}, ${vessel.audits_per_year.cyber[currentYear].auditors.first_name}`
                      : '' }}
                    </div>
                  </div>
                </div>
                <!--END CYBER-->
              </td>
              <td class="align-middle py-1">
                <div class="dropdown dropright">
                  <button
                    id="actionDropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="mr-2  ml-2 btn btn-sm btn-secondary force-white-all"
                    data-toggle="dropdown"
                  >
                    <font-awesome-icon icon="cogs"/>
                  </button>
                  <div aria-labelledby="actionDropdown" class="dropdown-menu py-0" style="min-height: 50px">
                    <button class="dropdown-item text-secondary font-weight-bolder"
                            @click="viewVesselAuditRecord(vessel.id)">
                      <font-awesome-icon icon="eye"/>
                      View
                    </button>
                    <button class="dropdown-item text-secondary font-weight-bolder"
                            @click="viewVesselAuditRecordNewTab(vessel.id)">
                      <font-awesome-icon icon="eye"/>
                      View on New Tab
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </template>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {vueAppMixin} from "@/mixins/vueAppMixin";
import AppLoading from "@/components/elements/AppLoading";

import _ from 'lodash';
import {permissionMixin} from "@/mixins/permissionMixins";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import SorterArrow from "@/components/common/SorterArrow.vue";
import FilterLikeExcel from "@/components/common/FilterLikeExcel.vue";
import {AlertService} from "@/services/AlertService";

export default {

  mixins: [vueAppMixin,permissionMixin,PaginationMixin],
  components: {AppLoading, SorterArrow, FilterLikeExcel},

  name: 'VesselList',
  data() {
    return {
      params: {
        active: 1,
        page:1,
        search:'',
      },
      requestPayload : {
        filter : {},
        sort : '',
        page : 1,
        active: 1,
        search: '',
      },

      allModuleFilterParams : [],
      loading: false,
      currentYear : new Date().getFullYear(),
      previousYear: new Date().getFullYear() - 1,
      beforePreviousYear: new Date().getFullYear() - 2,
    }
  },
  methods: {
    backgroundColor() {
      return backgroundColor
    },
    ...mapActions([
      'getVessels',
      'deleteVessel',
      'downloadVesselAuditReportStatusHistory'
    ]),
    setFilterParam(filterParam, dataLength) {
      const moduleFilterParamIndex = this.allModuleFilterParams.findIndex(item => item.column_name === filterParam.column_name);
      if (moduleFilterParamIndex === -1) {
        if (filterParam.direction === '' && filterParam.where_in.length === 0) {
          return;
        }
        this.allModuleFilterParams.push(filterParam);
      } else {
        if (filterParam.direction === '' && filterParam.where_in.length === dataLength) {
          this.allModuleFilterParams.splice(moduleFilterParamIndex, 1)
        } else {
          this.allModuleFilterParams[moduleFilterParamIndex] = filterParam;
        }
      }

      this.requestPayload.filter = {};
      this.allModuleFilterParams.forEach(item => {
        if (item.column_name !== filterParam.column_name) {
          item.direction = '';
        }
        this.requestPayload.filter[item.column_name] = item.where_in;
      });

      const sortIndex = this.allModuleFilterParams.findIndex(item => item.direction !== '');
      if (sortIndex === -1) {
        this.setVesselsToTable(1);
        return;
      }
      const filterParamWithSort = this.allModuleFilterParams[sortIndex];
      const sortSign = filterParamWithSort.direction === 'desc' ? '-' : '';
      this.requestPayload.sort = sortSign + filterParamWithSort.column_name;
      this.setVesselsToTable(1);
    },
    async viewVesselAuditRecord(vesselAuditRecordId) {
      await this.$router.push(
        {
          name: 'VesselAuditRecordList',
          params: {
            vessel_id: vesselAuditRecordId,
          },
        },

      ).catch(() => {})
    },
    async viewVesselAuditRecordNewTab(vesselAuditRecordId) {
      const route= this.$router.resolve(
        {
          name: 'VesselAuditRecordList',
          params: {
            vessel_id: vesselAuditRecordId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async setVesselsToTable(page=1) {
      this.loading = true;
      this.requestPayload.page=page
      await this.getVessels(this.requestPayload)
      this.loading = false;
    },
    runCallBack(param) {
      this.params.orderBy = param.orderBy;
      this.params.direction = param.direction;
      if (param.direction === '') {
        this.currentOrderBy = '';
      }
      this.setVesselsToTable(1);
    },
    async downloadReportStatusHistory() {
      swal.fire({
        'title': `GENERATING VESSEL AUDIT REPORTS STATUS HISTORY <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      const response = await this.downloadVesselAuditReportStatusHistory({
        params : this.requestPayload
      });
      swal.close();

      if (response === false) {
        return AlertService.errorAlert('Theres an error downloading the file. Please try again later!', 'DOWNLOADING FILE');
      }
      let mime_type = 'application/vnd.ms-excel';
      let url = window.URL.createObjectURL(new Blob([response],{type:mime_type}))

      let filename=`VESSELS_AUDITS_STATUS_HISTORY_REPORT.xlsx`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    }
  },
  computed: {
    ...mapGetters([
      'pagination',
      'vesselList',
      'isLoading',
      'updated_report_status_names',
    ]),
    lastThreeYears() {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: 3 }, (_, i) => currentYear - i).reverse();
    }
  },
  async created() {
    this.setVessels = _.debounce(this.setVesselsToTable, 750)
    await this.setVesselsToTable();
  },
  watch: {
    'requestPayload.active'() {
      this.setVessels()
    },
    'requestPayload.search'(){
      this.setVessels();
    }
  },

  destroyed() {
    this.params.active = 1;
  }

}
</script>

<style scoped lang="scss">
</style>
